export const SOCIAL_MEDIA_LIST = [
  {
    type: 'facebook',
    url: 'https://www.facebook.com/MissHallsSchool',
  },
  {
    type: 'instagram',
    url: 'https://www.instagram.com/misshallsschool/',
  },
  {
    type: 'youtube',
    url: 'https://www.youtube.com/user/misshallsschool',
  },
];
